
import request from "@/http";
/**
 * 获取用户推荐人/好友列表
 * @param {*} data
 * @returns
 */
const getFriendList=(data)=>{
    let {begin_idx,limit,id_public_user_info,isloading}=data;
    return request.get({
        url:"duzikai_api_mgr_public_user_info",
        data:{
            invoke_method:"public_page_4m_load_user_list",
            pre_db_para_begin_idx:begin_idx,
            pre_db_para_length_4_list:limit,
            upline_id_user:id_public_user_info,
            'public_user_info.user_remark_001_is_not_null': true,
        },
        loading:{
            enabled:isloading
        }
    })
}

const getUplineUser=(data)=>{
    let {id_public_user_info,begin_idx,limit,isloading}=data;
    return request.get({
        url:"duzikai_api_mgr_public_user_info",
        data:{
            invoke_method:"public_page_4m_load_user_list",
            pre_db_para_begin_idx:begin_idx,
            pre_db_para_length_4_list:limit,
            id_public_user_info:id_public_user_info,

        },
        loading:{
            enabled:isloading
        }
    })
}

export default {
    getFriendList,
    getUplineUser
}
